<!-- Hidden file input -->
<input
  #fileInput
  type="file"
  [accept]="inputAccept()"
  [attr.capture]="captureAttribute()"
  class="sr-only"
  tabindex="-1"
  aria-hidden="true"
  (change)="onFileChange($event)"
/>

@switch(type()) { @case ('circle-button') {
<button joii-button [iconOnly]="true" [variant]="'secondary'" [icon]="icon()" (click)="onButtonClick()"></button>
} @case ('icon-only') {
<button
  joii-inline-button
  [variant]="'secondary'"
  [borderless]="true"
  [iconOnly]="true"
  [prefixIcon]="icon()"
  (click)="onButtonClick()"
></button>
} }
